"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ignoreGoogleMapEvents = ignoreGoogleMapEvents;
exports.default = exports.testHooks = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _throttle2 = _interopRequireDefault(require("lodash/throttle"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _ZillowMapContext = _interopRequireDefault(require("../ZillowMapContext"));

var _ZillowMapLayer = _interopRequireDefault(require("../ZillowMapLayer"));

var _Parcel = _interopRequireDefault(require("./Parcel"));

var _DrawSearchBoundary = _interopRequireDefault(require("./DrawSearchBoundary"));

var _ClickToSeeMore = _interopRequireDefault(require("./ClickToSeeMore"));

var mapComboUtils = _interopRequireWildcard(require("../util/mapComboUtils"));

var _mapPositionUtils = require("../util/mapPositionUtils");

var _constants = require("../util/constants");

var _drawSearchUtils = require("../util/drawSearchUtils");

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/BoundaryManager/BoundaryManager.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint global-require: 0 import/first: 0 */
if (typeof window !== 'undefined') {
  require("whatwg-fetch");
}

var TILE_OFFSET = 2;
var env = 'map-pog.develop.zillow.net';
var pbs = true;
var communities = true;
var ver = 1;
var MAX_ZOOM_WITH_REGIONS = 16;
var debugTilePoly = [{
  holes: [],
  mbr: [],
  shell: [0, 0, 0, 256, 256, 256, 256, 0, 0, 0]
}];
var GOOGLE_HAND_CURSOR = 'url(https://maps.gstatic.com/mapfiles/openhand_8_8.cur), default';
var mousePointer = {
  cursor: 'pointer'
};
var mouseHand = {
  cursor: GOOGLE_HAND_CURSOR
};

var mapContextToProps = function mapContextToProps(props) {
  return _react.default.createElement(_ZillowMapContext.default.Consumer, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52
    },
    __self: this
  }, function (contextData) {
    return _react.default.createElement(BoundaryManager, _extends({}, props, {
      gmap: contextData.gmap,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 54
      },
      __self: this
    }));
  });
};

var STATE_REGION_TYPE = 2;

function findHoveredRegion(translatedX, translatedY, tile) {
  return (0, _find2.default)(tile.regions, function (region) {
    if (region.id === 0) {
      return false;
    }

    return region.polygons.some(function (polygon) {
      return (0, _mapPositionUtils.isScreenXYInsideMinimumBoundingRect)(translatedX, translatedY, polygon.mbr) && (0, _mapPositionUtils.isScreenXYInPolygon)(translatedX, translatedY, polygon.shell);
    });
  });
}

function ignoreGoogleMapEvents() {
  // Mark the shared flag as map content clicked.
  // Then use request animation frame to clear the flag after the stack unwinds.
  // This will let any virtual events fired by google map know that the click event
  // was on map positioned content.
  // (Used by Boundary Manager)
  if (!window.mapPositionClicked) {
    window.mapPositionClicked = true;
    window.requestAnimationFrame(function () {
      window.mapPositionClicked = false;
    });
  }
}

var BoundaryManager =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(BoundaryManager, _PureComponent);

  function BoundaryManager() {
    var _this;

    _this = _PureComponent.call(this) || this;

    _this.onMouseMove = function (ev) {
      if (!_this.props.isTouchInterfacePreferred && (_this.props.onHoverRegionCallback || _this.props.onHoverParcelCallback)) {
        _this.checkForHovered(ev.pixel.x, ev.pixel.y, ev.latLng.lat(), ev.latLng.lng());
      }
    };

    _this.onMouseOver = function () {
      _this.updateMouseState({
        mouseOnMap: true
      });
    };

    _this.onMouseOut = function () {
      _this.updateMouseState({
        mouseOnMap: false,
        mouseLat: null,
        mouseLng: null
      });
    };

    _this.onIdle = function () {
      if (_this.state.isMapZooming) {
        _this.setState({
          isMapZooming: false
        });
      }

      _this.updateTileSet();
    };

    _this.onZoomChange = function (isFirstDraw) {
      if (!_this.state.isMapZooming && !isFirstDraw) {
        _this.setState({
          isMapZooming: true
        });
      }
    };

    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    _this.state = {
      tiles: [],
      edges: {},
      hoveredParcelId: null,
      isMapIdle: true,
      isMapZooming: false
    };
    _this.convertedLatLngParcels = {};
    _this.idleListener = null;
    _this.mouseMoveListener = null;
    return _this;
  }

  var _proto = BoundaryManager.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.registerListeners();
    this.updateTileSet();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.gmap !== this.props.gmap) {
      this.unregisterListeners();
      this.registerListeners();
      this.updateTileSet();
    }

    if (this.props.regionId !== prevProps.regionId) {
      // eslint-disable-next-line
      this.setState({
        tiles: [],
        edges: {}
      }, this.updateTileSet);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unregisterListeners();
  };

  _proto.onMouseClick = function onMouseClick(ev) {
    var _this$props = this.props,
        onClickMapAnywhere = _this$props.onClickMapAnywhere,
        onShowAllHomesClick = _this$props.onShowAllHomesClick; // ignore clicks that have already interacted with map positioned content

    if (!window.mapPositionClicked) {
      if (this.shouldShowAllHomesCursor()) {
        onShowAllHomesClick();
      } else {
        this.clickRegion(ev.pixel.x, ev.pixel.y);
      }

      this.clickParcel(ev.pixel.x, ev.pixel.y); // clickParcel and onClickMapAnywhere behave asynchronously and race
      // we set window.mapPositionClicked in clickParcel to regulate this asynchronisity

      if (!window.mapPositionClicked && onClickMapAnywhere !== null) {
        onClickMapAnywhere();
      }
    }
  };

  _proto.onMouseClickDelayed = function onMouseClickDelayed(ev) {
    var _this2 = this;

    // boundary manager events go down the google maps event handler
    // property marker events go down the react event handler
    // this puts the bm google click event behind the pm react event
    window.requestAnimationFrame(function () {
      return _this2.onMouseClick(ev);
    });
  };

  /**
   * Return the zoom level currently set on the google map instance.
   * We have to adjust this by 1 because of a deeply integrated zoom difference
   * in backend services.
   * @returns {number}
   */
  _proto.getZoom = function getZoom() {
    return this.props.gmap.getZoom() - 1;
  };

  _proto.getCursorType = function getCursorType() {
    // If the cursor is outside a selected region
    // then its clickable (to clear the selected boundary)
    // or if its over a parcel, its clickable to open the detail page
    // Either case, update the cursor to indicate to the user they are over something they can click
    if (this.state.hoveredParcelId || this.getZoom() <= MAX_ZOOM_WITH_REGIONS && this.props.regionId && !this.state.hoveredRegion || (this.props.customPolygonWkt || this.props.customPolygonArray && this.props.customPolygonArray.length) && !this.state.hoveredRegion) {
      this.props.gmap.setOptions({
        draggableCursor: 'pointer'
      });
      return mousePointer;
    }

    this.props.gmap.setOptions({
      draggableCursor: GOOGLE_HAND_CURSOR
    });
    return mouseHand;
  }
  /**
   * Gets the current google map bounds,
   * then uses those to generate the column and row numbers we are currently
   * viewing for requesting polygons from map combo service.
   * @returns {Array}
   */
  ;

  _proto.getTilesFromMapBounds = function getTilesFromMapBounds() {
    var tiles = [];
    var gmap = this.props.gmap; // This is the only place that we don't subtract 1 from the zoom,
    // because if we do it will scale the rectangle incorrectly

    var zoomLevel = gmap.getZoom();
    var projection = gmap.getProjection();
    var rectLatLngBounds = gmap.getBounds();

    if (!projection || !rectLatLngBounds) {
      return [];
    } // fromLatLngToPoint converts latitude + longitude coordinates to mercator projection
    // https://developers.google.com/maps/documentation/javascript/coordinates#world-coordinates


    var rectTopRight = projection.fromLatLngToPoint(rectLatLngBounds.getNorthEast());
    var rectBottomLeft = projection.fromLatLngToPoint(rectLatLngBounds.getSouthWest()); // The zoom scale is used to convert mercator projection points to the current zoom level
    // https://developers.google.com/maps/documentation/javascript/coordinates#pixel-coordinates
    // eslint-disable-next-line no-restricted-properties

    var zoomScale = Math.pow(2, zoomLevel);
    var scaledRectWidth = Math.abs(rectTopRight.x - rectBottomLeft.x) * zoomScale;
    var scaledRectHeight = Math.abs(rectTopRight.y - rectBottomLeft.y) * zoomScale;
    var numRowTiles = Math.floor(scaledRectHeight / _constants.GOOGLE_TILE_SIZE);
    var numColTiles = Math.floor(scaledRectWidth / _constants.GOOGLE_TILE_SIZE);
    var firstRowTile = Math.max(0, Math.floor(rectTopRight.y * zoomScale / _constants.GOOGLE_TILE_SIZE) - TILE_OFFSET);
    var firstColTile = Math.max(0, Math.floor(rectBottomLeft.x * zoomScale / _constants.GOOGLE_TILE_SIZE) - TILE_OFFSET);
    var lastRowTileIndex = firstRowTile + numRowTiles + TILE_OFFSET * 2;
    var lastColTileIndex = firstColTile + numColTiles + TILE_OFFSET * 2;

    for (var row = firstRowTile; row <= lastRowTileIndex; ++row) {
      for (var column = firstColTile; column <= lastColTileIndex; ++column) {
        tiles.push({
          row: row,
          column: column,
          key: mapComboUtils.generateTileKey(row, column)
        });
      }
    }

    return tiles;
  };

  _proto.couldShowAllHomesCursor = function couldShowAllHomesCursor() {
    return this.props.gmap && !this.props.isTouchInterfacePreferred && this.props.onShowAllHomesClick && this.getZoom() <= MAX_ZOOM_WITH_REGIONS && (this.props.regionId || this.props.customPolygonArray && this.props.customPolygonArray.length > 0 || this.props.customPolygonWkt);
  };

  _proto.shouldShowAllHomesCursor = function shouldShowAllHomesCursor() {
    return this.couldShowAllHomesCursor() && !this.state.hoveredRegion && !this.state.hoveredParcel && this.state.mouseLat && this.state.mouseLng;
  };

  _proto.registerListeners = function registerListeners() {
    if (this.props.gmap) {
      this.idleListener = this.props.gmap.addListener('idle', this.onIdle);
      this.mouseMoveListener = this.props.gmap.addListener('mousemove', (0, _throttle2.default)(this.onMouseMove, 30));
      this.mouseClickListener = this.props.gmap.addListener('click', (0, _throttle2.default)(this.onMouseClickDelayed, 30));
      this.mouseOutListener = this.props.gmap.addListener('mouseout', (0, _throttle2.default)(this.onMouseOut, 30));
      this.mouseOverListener = this.props.gmap.addListener('mouseover', (0, _throttle2.default)(this.onMouseOver, 30));
    }
  };

  _proto.updateMouseState = function updateMouseState(mouseState) {
    // We only want to update the state of the mouse if the all homes cursor is possible.
    // otherwise we can end up with unneeded re-renders.
    if (this.couldShowAllHomesCursor()) {
      this.setState(mouseState);
    }
  };

  _proto.unregisterListeners = function unregisterListeners() {
    if (this.idleListener) {
      google.maps.event.removeListener(this.idleListener);
    }

    if (this.mouseMoveListener) {
      google.maps.event.removeListener(this.mouseMoveListener);
    }

    if (this.mouseClickListener) {
      google.maps.event.removeListener(this.mouseClickListener);
    }

    if (this.mouseOutListener) {
      google.maps.event.removeListener(this.mouseOutListener);
    }

    if (this.mouseOverListener) {
      google.maps.event.removeListener(this.mouseOverListener);
    }
  };

  _proto.checkHoveredParcel = function checkHoveredParcel(translatedX, translatedY, tile, gmap) {
    var hoveredParcel = (0, _find2.default)(tile.parcels, function (parcel) {
      return parcel.id !== 0 && (0, _mapPositionUtils.isScreenXYInsideMinimumBoundingRect)(translatedX, translatedY, parcel.mbr) && (0, _mapPositionUtils.isScreenXYInPolygon)(translatedX, translatedY, parcel.polygons[0].shell);
    });

    if (hoveredParcel) {
      if (hoveredParcel.id !== this.state.hoveredParcelId) {
        this.setState({
          hoveredParcelId: hoveredParcel.id
        });

        if ((0, _isEmpty2.default)(this.convertedLatLngParcels[hoveredParcel.id])) {
          this.convertedLatLngParcels[hoveredParcel.id] = (0, _mapPositionUtils.convertParcelToLatLng)(hoveredParcel, tile.row, tile.column, gmap);
        }

        this.props.onHoverParcelCallback && this.props.onHoverParcelCallback({
          baseParcel: hoveredParcel,
          latLngParcel: this.convertedLatLngParcels[hoveredParcel.id],
          tileRow: tile.row,
          tileCol: tile.column
        });
      }

      this.setState({
        hoveredRegion: null
      });
      this.props.onHoverRegionCallback && this.props.onHoverRegionCallback(null);
      return true;
    }

    if (this.state.hoveredParcelId) {
      this.setState({
        hoveredParcelId: null
      });
      this.props.onHoverParcelCallback && this.props.onHoverParcelCallback(null);
    }

    return false;
  };

  _proto.clickParcel = function clickParcel(mouseX, mouseY) {
    var _this$props2 = this.props,
        gmap = _this$props2.gmap,
        onParcelClick = _this$props2.onParcelClick;

    if (!onParcelClick || !gmap) {
      return;
    }

    var _this$findTile = this.findTile(mouseX, mouseY),
        tile = _this$findTile.tile,
        translatedX = _this$findTile.translatedX,
        translatedY = _this$findTile.translatedY;

    if (tile) {
      var overParcel = (0, _find2.default)(tile.parcels, function (parcel) {
        return parcel.id !== 0 && (0, _mapPositionUtils.isScreenXYInsideMinimumBoundingRect)(translatedX, translatedY, parcel.mbr) && (0, _mapPositionUtils.isScreenXYInPolygon)(translatedX, translatedY, parcel.polygons[0].shell);
      });

      if (overParcel) {
        if ((0, _isEmpty2.default)(this.convertedLatLngParcels[overParcel.id])) {
          this.convertedLatLngParcels[overParcel.id] = (0, _mapPositionUtils.convertParcelToLatLng)(overParcel, tile.row, tile.column, gmap);
        }

        ignoreGoogleMapEvents();
        this.props.onParcelClick({
          baseParcel: overParcel,
          latLngParcel: this.convertedLatLngParcels[overParcel.id],
          tileRow: tile.row,
          tileCol: tile.column
        });
      }
    }
  };

  _proto.checkHoveredRegion = function checkHoveredRegion(translatedX, translatedY, tile, gmap) {
    var hoveredRegion = findHoveredRegion(translatedX, translatedY, tile);

    if (hoveredRegion) {
      if (hoveredRegion.id !== this.state.hoveredRegion) {
        this.setState({
          hoveredRegion: hoveredRegion.id
        });

        if ((0, _isEmpty2.default)(this.convertedLatLngParcels[hoveredRegion.id])) {
          this.convertedLatLngParcels[hoveredRegion.id] = (0, _mapPositionUtils.convertParcelToLatLng)(hoveredRegion, tile.row, tile.column, gmap);
        }

        this.props.onHoverRegionCallback && this.props.onHoverRegionCallback({
          baseRegion: hoveredRegion,
          tileRow: tile.row,
          tileCol: tile.column
        });
      }
    }

    return !!hoveredRegion;
  };

  _proto.checkHoveredCustomRegion = function checkHoveredCustomRegion(mouseX, mouseY, tile, gmap) {
    var _this$props3 = this.props,
        customPolygonArray = _this$props3.customPolygonArray,
        customPolygonWkt = _this$props3.customPolygonWkt;
    var noRegion = (0, _isEmpty2.default)(customPolygonArray) && (0, _isEmpty2.default)(customPolygonWkt);

    if (!noRegion) {
      var customPolygonsWithScreenCoordinates = !(0, _isEmpty2.default)(customPolygonArray) ? customPolygonArray.map(function (customPoly) {
        return (0, _mapPositionUtils.convertPolygonToScreenXY)(customPoly, gmap);
      }) : (0, _drawSearchUtils.convertWktStringToArrayOfPolygonCoordinates)(customPolygonWkt, gmap);
      var insideCustomPoly = customPolygonsWithScreenCoordinates.some(function (polygon) {
        return (0, _mapPositionUtils.isScreenXYInPolygon)(mouseX, mouseY, polygon);
      });

      if (insideCustomPoly) {
        var hoveredCustomRegion = 'custom';
        this.setState({
          hoveredRegion: hoveredCustomRegion
        });
        this.props.onHoverRegionCallback && this.props.onHoverRegionCallback({
          baseRegion: hoveredCustomRegion,
          tileRow: tile.row,
          tileCol: tile.column
        });
      }

      return insideCustomPoly;
    }

    return false;
  };

  _proto.findTile = function findTile(mouseX, mouseY) {
    var gmap = this.props.gmap;
    var generateTileKey = mapComboUtils.generateTileKey;

    var _getTileRowColFromScr = (0, _mapPositionUtils.getTileRowColFromScreenCoords)(mouseX, mouseY, gmap),
        row = _getTileRowColFromScr.row,
        column = _getTileRowColFromScr.column;

    var generatedTileKey = generateTileKey(row, column);
    var tile = (0, _find2.default)(this.state.tiles, function (t) {
      return t.key === generatedTileKey;
    });
    var tileTopLeftPixelCoords = (0, _mapPositionUtils.getTileTopLeftScreenPixelCoordinates)(row, column, gmap);

    var _translateScreenXYFro = (0, _mapPositionUtils.translateScreenXYFromMapTile)(tileTopLeftPixelCoords, mouseX, mouseY),
        translatedX = _translateScreenXYFro.translatedX,
        translatedY = _translateScreenXYFro.translatedY;

    return {
      tile: tile,
      translatedX: translatedX,
      translatedY: translatedY
    };
  };

  _proto.clickRegion = function clickRegion(mouseX, mouseY) {
    var _this3 = this;

    var _this$props4 = this.props,
        gmap = _this$props4.gmap,
        isTouchInterfacePreferred = _this$props4.isTouchInterfacePreferred,
        onRegionSelection = _this$props4.onRegionSelection; // if map not initialized

    if (!gmap || // or using a touch interface
    isTouchInterfacePreferred || // or no handler to call
    !onRegionSelection || // // or we are zoomed in further than state click level
    gmap.getZoom() > _constants.MAXIMUM_STATE_CLICK_ZOOM) {
      // then don't test clicking regions.
      return false;
    }

    var _this$findTile2 = this.findTile(mouseX, mouseY),
        tile = _this$findTile2.tile,
        translatedX = _this$findTile2.translatedX,
        translatedY = _this$findTile2.translatedY;

    if (tile) {
      var hoveredRegion = findHoveredRegion(translatedX, translatedY, tile);

      if (hoveredRegion && // Only fetch states
      hoveredRegion.type === STATE_REGION_TYPE && // Don't fetch the region if we already have it selected
      hoveredRegion.id !== this.props.regionId) {
        // example url: https://www.develop.zillow.net/search/GetRegionSelection.htm?regionId=59

        /* example response:
        {
            regionId: 59,
            selectionName: "Washington",
            regionURLString: "WA",
            regionType: 2,
            boundingRect: {
                sw: {
                    lat: 45543541,
                    lon: -124848973
                },
                ne: {
                    lat: 49002494,
                    lon: -116915579
                }
            }
        } */
        var requestUrl = "/search/GetRegionSelection.htm?regionId=" + hoveredRegion.id;
        fetch(requestUrl).then(function (response) {
          return response.json();
        }).then(function (decodedString) {
          if ((0, _isEmpty2.default)(decodedString)) {
            return;
          }

          _this3.setState({
            tiles: [],
            edges: {}
          }, _this3.updateTileSet);

          _this3.props.onRegionSelection(decodedString);
        }).catch(function (err) {
          return console.error(err);
        });
      }

      return !!hoveredRegion;
    }

    return false;
  };

  _proto.checkForHovered = function checkForHovered(mouseX, mouseY, lat, lng) {
    var gmap = this.props.gmap;

    var _this$findTile3 = this.findTile(mouseX, mouseY),
        tile = _this$findTile3.tile,
        translatedX = _this$findTile3.translatedX,
        translatedY = _this$findTile3.translatedY;

    if (!tile) {
      return;
    }

    this.updateMouseState({
      mouseLat: lat,
      mouseLng: lng
    });

    if ((0, _isEmpty2.default)(tile)) {
      this.setState({
        hoveredRegion: null,
        hoveredParcel: null
      });
      return;
    }

    if (!this.checkHoveredParcel(translatedX, translatedY, tile, gmap)) {
      if (!this.checkHoveredRegion(translatedX, translatedY, tile, gmap) && !this.checkHoveredCustomRegion(mouseX, mouseY, tile, gmap)) {
        if (this.state.hoveredRegion) {
          this.setState({
            hoveredRegion: null
          });
        }

        this.props.onHoverRegionCallback && this.props.onHoverRegionCallback(null);
      }
    }
  }
  /**
   * After each change of the map we get the old tile set, and the new tile set.
   * Then we request any tiles in the new set we don't already have, filter out
   * tiles that are no longer viewable, and merge the two to form the new tile data.
   */
  ;

  _proto.updateTileSet = function updateTileSet() {
    var _this4 = this;

    if (!this.props.gmap) {
      return;
    }

    var oldTileSet = _toConsumableArray(this.state.tiles);

    var edges = this.state.edges;
    var newTileSet = this.getTilesFromMapBounds(); // Only get new tiles if our current bounds are outside
    // previous edges

    if ((0, _isEmpty2.default)(newTileSet) || !mapComboUtils.areTileUpdatesNeeded(newTileSet, edges)) {
      return;
    } // Only fetch tiles that we don't already have


    var tilesToFetch = newTileSet.filter(function (tile) {
      return oldTileSet.findIndex(function (oldTile) {
        return oldTile.key === tile.key;
      }) < 0;
    });
    var requestUrl = this.buildRequestUrl(tilesToFetch); // fetch new tiles

    fetch(requestUrl).then(function (response) {
      return response.text();
    }).then(function (decodedString) {
      if ((0, _isEmpty2.default)(decodedString)) {
        return;
      }

      var mapComboJson = mapComboUtils.convertMapComboResponseToArray(decodedString);

      _this4.setState(function (prevState) {
        var newEdges = mapComboUtils.getNewEdges(mapComboJson, prevState.edges);
        var filteredOldSet = mapComboUtils.filterHiddenTiles(newEdges, oldTileSet);
        return {
          tiles: [].concat(_toConsumableArray(mapComboJson), _toConsumableArray(filteredOldSet)),
          edges: newEdges
        };
      }); // If we are fetching new tiles clear the latLngParcel cache in order to avoid
      // taking up too much memory.


      _this4.convertedLatLngParcels = {};
    }).catch(function (err) {
      return console.error(err);
    });
  }
  /**
   * Generates the request to the map combo service. The service expects a url along the lines of
   * /map/combo?col0=123&col1=123&col2=124&row0=1&row2=2&row3=3
   * @param tiles
   * @returns {string}
   */
  ;

  _proto.buildRequestUrl = function buildRequestUrl(tiles) {
    // eslint-disable-next-line no-extend-native
    String.prototype.appendParam = function appendParam(key, value) {
      return "" + this.valueOf() + (this.endsWith('?') ? '' : '&') + key + "=" + value;
    };

    var baseMapComboUrl = this.props.mapComboUrl + "/map/combo?";
    return tiles.sort(function (a, b) {
      return a.row - b.row || a.column - b.column;
    }).reduce(function (acc, tile, index) {
      return acc.appendParam("row" + index, tile.row).appendParam("col" + index, tile.column);
    }, baseMapComboUrl.appendParam('env', env).appendParam('pbs', pbs).appendParam('communities', communities).appendParam('ver', ver).appendParam('zoom', this.getZoom()).appendParam('rid', this.props.regionId || ''));
  };

  _proto.renderCustomRegions = function renderCustomRegions() {
    if (!this.props.gmap || this.props.regionId) {
      return null;
    }

    var _this$props5 = this.props,
        gmap = _this$props5.gmap,
        customPolygonArray = _this$props5.customPolygonArray,
        customPolygonWkt = _this$props5.customPolygonWkt;
    var noRegion = (0, _isEmpty2.default)(customPolygonArray) && (0, _isEmpty2.default)(customPolygonWkt); // Because this is being called in the render method, the gmap might not be fully loaded so
    // we need to wait until it has a projection to do the necessary calculations.
    // We also don't have an accurate projection until the map has settled, so we can't scale
    // the custom region appropriately. While the map is zooming hide the boundary

    var shouldNotRender = !this.state.isMapIdle || noRegion || !gmap.getProjection();

    if (shouldNotRender) {
      return null;
    }

    var topRight = gmap.getBounds().getNorthEast();
    var bottomLeft = gmap.getBounds().getSouthWest(); // polygons take priority over wkt

    var polygons = !(0, _isEmpty2.default)(customPolygonArray) ? customPolygonArray.map(function (customPoly) {
      return (0, _mapPositionUtils.convertPolygonToScreenXY)(customPoly, gmap);
    }) : (0, _drawSearchUtils.convertWktStringToArrayOfPolygonCoordinates)(customPolygonWkt, gmap);
    return _react.default.createElement(_DrawSearchBoundary.default, {
      style: this.getCursorType(),
      id: "custom-region-boundary",
      key: "custom-region-boundary",
      northSouthLat: topRight.lat(),
      eastWestLng: bottomLeft.lng(),
      polygons: polygons,
      strokeType: "poly-region",
      fillCompletedRegion: this.props.fillCustomRegions,
      allowGoogleMapEvents: true,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 707
      },
      __self: this
    });
  };

  _proto.renderRegionBoundaries = function renderRegionBoundaries() {
    var _this5 = this;

    if (!this.props.gmap) {
      return null;
    }

    var zoomLevel = this.getZoom();
    var parcelObjectCounter = 0;
    return this.state.tiles.reduce(function (acc, tile) {
      var regions = tile.regions || [];
      var parcels = regions.filter(function (_ref) {
        var polygons = _ref.polygons;
        return polygons.length > 0;
      }).map(function (region) {
        var polygons = region.polygons,
            type = region.type,
            id = region.id;
        var parcelId = tile.key + "_" + id;
        parcelObjectCounter += 1;
        return _react.default.createElement(_Parcel.default, {
          style: _this5.getCursorType(),
          id: parcelId,
          key: parcelObjectCounter,
          row: tile.row,
          column: tile.column,
          zoom: zoomLevel,
          polygons: polygons,
          strokeType: "poly-region",
          isState: type === STATE_REGION_TYPE && id !== _this5.props.regionId,
          isMouseOver: region.id === _this5.state.hoveredRegion,
          allowGoogleMapEvents: true,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 741
          },
          __self: this
        });
      });
      return [].concat(_toConsumableArray(acc), [parcels]);
    }, []);
  };

  _proto.renderParcels = function renderParcels() {
    var _this6 = this;

    if (!this.props.gmap) {
      return null;
    }

    var tiles = this.state.tiles;
    var zoomLevel = this.getZoom();
    var minParcelZoomLevel = 17; // We only have parcel data at zoom levels 17 and above so we can exit early;

    if (zoomLevel < minParcelZoomLevel) {
      return null;
    }

    var parcelHashMap = {};
    var fullSize = true;
    tiles.filter(function (tile) {
      return tile.parcels.length > 0;
    }).forEach(function (_ref2) {
      var parcels = _ref2.parcels,
          key = _ref2.key,
          row = _ref2.row,
          column = _ref2.column;
      parcels.forEach(function (parcel) {
        // If the parcel is missing an id
        // then assign it a reproducable id based on MBR
        // this should distinguish it well from other non id'd parcels on the map
        // preventing them from be erronously deduped.   But still deduped if they
        // also have the same MBR.
        if (!parcel.id && parcel.mbr) {
          for (var i = 0; i < parcel.mbr.length; ++i) {
            // Modifying parcel so this only has to be done on first render of the data.
            // eslint-disable-next-line no-param-reassign, no-bitwise
            parcel.id = parcel.mbr[i] + (parcel.id << 8);
          }
        }

        var id = parcel.id,
            polygons = parcel.polygons;

        if (!parcelHashMap[id]) {
          parcelHashMap[id] = _react.default.createElement(_Parcel.default, {
            style: _this6.getCursorType(),
            id: "" + id,
            key: "parcel_" + id + "_" + key + "_" + zoomLevel,
            row: row,
            column: column,
            zoom: zoomLevel,
            polygons: polygons,
            strokeType: "poly-parcel",
            fullSize: fullSize,
            isMouseOver: id === _this6.state.hoveredParcelId,
            allowGoogleMapEvents: true,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 798
            },
            __self: this
          });
        }
      });
    });
    return Object.values(parcelHashMap);
  }
  /**
   * For use in debugging only. Renders out the current grid on the map.
   * @returns {*}
   */
  ;

  _proto.renderTileOutlines = function renderTileOutlines() {
    var _this7 = this;

    if (!this.props.gmap) {
      return null;
    }

    var tiles = this.state.tiles;
    var debugMode = this.props.debugMode;

    if (tiles.length === 0 || !debugMode) {
      return null;
    }

    return tiles.map(function (tile) {
      return _react.default.createElement(_Parcel.default, {
        id: "show-tile-" + tile.key,
        key: "show_tile_" + tile.key,
        row: tile.row,
        column: tile.column,
        zoom: _this7.getZoom(),
        debug: debugMode,
        polygons: debugTilePoly,
        strokeType: "poly-region",
        allowGoogleClicks: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 834
        },
        __self: this
      });
    });
  };

  _proto.renderMouseFollower = function renderMouseFollower() {
    if (this.shouldShowAllHomesCursor() && this.state.mouseOnMap) {
      return _react.default.createElement(_ClickToSeeMore.default, {
        eastWestLng: this.state.mouseLng,
        northSouthLat: this.state.mouseLat,
        allowGoogleMapEvents: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 851
        },
        __self: this
      }, "Click to remove boundary");
    }

    return null;
  };

  _proto.render = function render() {
    return _react.default.createElement(_ZillowMapLayer.default, {
      ariaHidden: true // Removing elements from the map layer while it is drawing causes issues with
      // the google map. So rather than stopping rendering them, we just hide them.
      ,
      styles: {
        visibility: this.state.isMapZooming ? 'hidden' : 'visible'
      },
      onZoomChangeCallback: this.onZoomChange,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 866
      },
      __self: this
    }, this.renderParcels(), this.renderRegionBoundaries(), this.renderCustomRegions(), this.renderTileOutlines(), this.renderMouseFollower());
  };

  return BoundaryManager;
}(_react.PureComponent);

BoundaryManager.propTypes = process.env.NODE_ENV !== "production" ? {
  gmap: _propTypes.default.object,
  regionId: _propTypes.default.number,
  mapComboUrl: _propTypes.default.string,
  customPolygonArray: _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.number)),
  customPolygonWkt: _propTypes.default.string,
  onHoverParcelCallback: _propTypes.default.func,
  onHoverRegionCallback: _propTypes.default.func,
  onShowAllHomesClick: _propTypes.default.func,
  onClickMapAnywhere: _propTypes.default.func,
  debugMode: _propTypes.default.bool,
  fillCustomRegions: _propTypes.default.bool,
  isTouchInterfacePreferred: _propTypes.default.bool,
  onRegionSelection: _propTypes.default.func,
  onParcelClick: _propTypes.default.func
} : {};
BoundaryManager.defaultProps = {
  regionId: null,
  mapComboUrl: 'https://www.zillowstatic.com',
  customPolygonArray: [],
  customPolygonWkt: '',
  onHoverParcelCallback: null,
  onHoverRegionCallback: null,
  onShowAllHomesClick: null,
  onClickMapAnywhere: null,
  debugMode: false,
  fillCustomRegions: false,
  isTouchInterfacePreferred: true,
  onRegionSelection: null,
  onParcelClick: null
};
var testHooks = {
  BoundaryManager: BoundaryManager,
  env: env,
  ver: ver,
  communities: communities,
  findHoveredRegion: findHoveredRegion
};
exports.testHooks = testHooks;
var _default = mapContextToProps;
exports.default = _default;